module.exports = __webpack_public_path__ + "img/angular.a2377a67.png";